import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "../../common/reduxQuery/helpers";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customBaseQuery(),
  endpoints: (build) => ({
    removePermissionFromUser: build.mutation<
      void,
      {
        userId: string;
        data: { permissions: Array<string> };
      }
    >({
      query: ({ userId, data }) => ({
        url: `/api/v1/user/${encodeURI(userId)}/permission`,
        body: data,
        method: "DELETE",
      }),
    }),
    addPermissionToUser: build.mutation<
      void,
      {
        userId: string;
        permission: string;
      }
    >({
      query: ({ userId, permission }) => ({
        url: `/api/v1/user/${encodeURI(userId)}/permission/${permission}`,
        method: "POST",
      }),
    }),
    updateUser: build.mutation<
      void,
      {
        userId: string;
        // Callers across several features send differently shaped profile +
        // metadata patches and the server contract is not modelled anywhere.
        // Typing this needs the update payload to be specified first.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        data: any;
      }
    >({
      query: ({ userId, data }) => ({
        url: `/api/v1/user/${encodeURI(userId)}/update`,
        body: data,
        method: "PUT",
      }),
    }),
    updatePassword: build.mutation<
      void,
      {
        userId: string;
        data: { password: string };
      }
    >({
      query: ({ userId, data }) => ({
        url: `/api/v1/user/${encodeURI(userId)}/password`,
        body: data,
        method: "PATCH",
      }),
    }),
  }),
});

export const {
  useRemovePermissionFromUserMutation,
  useAddPermissionToUserMutation,
  useUpdateUserMutation,
  useUpdatePasswordMutation,
} = userApi;
